@if (isVisible) {
  <form-control [question]="componentData" [flow]="flowComponent">
    <select class="screen-only" lunaInput [(ngModel)]="contextValue" #dropdown [id]="controlId" [name]="controlName" [formControl]="formGroup.controls[componentData.key]" (ngModelChange)="change()">
      @for (item of items|async; track item) {
        <option [ngValue]="item[idProperty]">
          {{item[displayProperty]}}
        </option>
      }
    </select>
  </form-control>
}
<div class="print-only">
  {{selectedValue}}
</div>
